import React, { useState } from 'react';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { all_routes } from '../../router/all_routes';

interface BannerProps {
    apiValues: any;
}



const Whatsnew: React.FC<BannerProps> = ({ apiValues }) => {

    const route = all_routes;

    const universities = [
        {
            name: "Monash University",
            location: "Australia",
            ranking: 58,
            students: 29912,
            img: "assets/img/course/course-22.jpg",
            icon: "assets/img/icons/course-01.svg",
            countries: [
                { name: "Australia", icon: "assets/img/icons/flags/au.svg" },
                { name: "USA", icon: "assets/img/icons/flags/us.svg" },
                { name: "UK", icon: "assets/img/icons/flags/uk.svg" },
                { name: "Canada", icon: "assets/img/icons/flags/ca.svg" },
                { name: "Germany", icon: "assets/img/icons/flags/de.svg" },
            ]
        },
        {
            name: "The University of Sydney",
            location: "Australia",
            ranking: 58,
            students: 29912,
            img: "assets/img/course/course-22.jpg",
            icon: "assets/img/icons/course-01.svg",
            countries: [
                { name: "Australia", icon: "assets/img/icons/flags/au.svg" },
                { name: "USA", icon: "assets/img/icons/flags/us.svg" },
                { name: "UK", icon: "assets/img/icons/flags/uk.svg" },
                { name: "Canada", icon: "assets/img/icons/flags/ca.svg" },
                { name: "Germany", icon: "assets/img/icons/flags/de.svg" },
            ]
        },
        {
            name: "The Australian National University",
            location: "Australia",
            ranking: 58,
            students: 29912,
            img: "assets/img/course/course-22.jpg",
            icon: "assets/img/icons/course-01.svg",
            countries: [
                { name: "Australia", icon: "assets/img/icons/flags/au.svg" },
                { name: "USA", icon: "assets/img/icons/flags/us.svg" },
                { name: "UK", icon: "assets/img/icons/flags/uk.svg" },
                { name: "Canada", icon: "assets/img/icons/flags/ca.svg" },
                { name: "Germany", icon: "assets/img/icons/flags/de.svg" },
            ]

        },
        {
            name: "The University of Adelaide",
            location: "Australia",
            ranking: 58,
            students: 29912,
            img: "assets/img/course/course-22.jpg",
            icon: "assets/img/icons/course-01.svg",
            countries: [
                { name: "Australia", icon: "assets/img/icons/flags/au.svg" },
                { name: "USA", icon: "assets/img/icons/flags/us.svg" },
                { name: "UK", icon: "assets/img/icons/flags/uk.svg" },
                { name: "Canada", icon: "assets/img/icons/flags/ca.svg" },
                { name: "Germany", icon: "assets/img/icons/flags/de.svg" },
            ]

        },
    ];

    const [selectedItems, setSelectedItems] = useState(Array(universities.length).fill(false));

    const handleItemClick = (index: number) => {
        setSelectedItems(prev => {
            const updated = [...prev];
            updated[index] = !updated[index];
            return updated;
        });
    };

    const whatsnewslider = {
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: false,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            {/* Whats New Section */}
            <div className="container feature-section position-relative">
                <div className="container">
                    {/* <ImageWithBasePath
                        src="assets/img/bg/feature-bg-01.png"
                        alt="img"
                        className="bg-star-01 img-fluid"
                    />
                    <ImageWithBasePath
                        src="assets/img/bg/feature-bg-02.png"
                        alt="img"
                        className="bg-star-02 img-fluid"
                    /> */}

                    {/* Heading */}

                    <div className="section-header text-start p-3">
                        <span className="section-badge">
                            {apiValues?.title}
                        </span>
                        <h2>
                            {apiValues?.description}
                        </h2>
                        <p>
                            {apiValues?.miniDescription}
                        </p>
                        <h5 className='text-[#1D1753] mt-3'>
                            {apiValues?.miniSecondDescription}
                        </h5>

                    </div>

                </div>

                {/* Slider */}
                {/* <Slider {...whatsnewslider} className="mt-3"> */}

                <div className='row'>

                    {

                        (Array.isArray(apiValues?.globalDest) ? apiValues?.globalDest : []).map((univ: any, index: number) => {

                            return (

                                <div className="col-md-4 item" key={index}>
                                    <div className="course-item-two course-item">
                                        <div className="course-img">
                                            <Link to="#">
                                                <ImageWithBasePath
                                                    source={univ?.destination?.countryImage}
                                                    alt="img"
                                                    className="img-fluid"
                                                />
                                            </Link>

                                        </div>

                                        <div className="course-content text-start">
                                            <div className="ms-2">
                                                <h5 className="subs-title mb-3">{univ?.destination?.countryName}</h5>
                                            </div>
                                        </div>

                                        <div className="border-bottom w-100 mb-3" />

                                        {/* Country flags */}
                                        <div className="mb-3">

                                            <div className="flex flex-wrap gap-3 mb-3">
                                                {

                                                    (Array.isArray(univ?.icons) ? univ?.icons : []).map((item: any, index: number) => {

                                                        return (
                                                            <div key={index} className="flex items-center gap-1 text-sm text-gray-700">

                                                                <ImageWithBasePath source={item} alt={item} className="w-20 h-12 object-contain" />
                                                            </div>
                                                        )
                                                    }) || []
                                                }

                                            </div>
                                        </div>




                                        <div className="d-flex align-items-center justify-content-center p-3">
                                            <Link
                                                to={route.Unlock}
                                                className="btn btn-danger btn-sm d-inline-flex align-items-center justify-content-center text-center"
                                                style={{
                                                    width: '200px',
                                                    padding: '10px'
                                                }}
                                            >
                                                {univ?.buttonText}
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            )
                        }) || []
                    }

                </div>

                {/* </Slider> */}
            </div>
        </>
    );
};

export default Whatsnew;
